'use client';
import React from 'react';
import Header from '@/components/organisms/header';
import useTranslation from '@/providers/I18n/hooks/useTranslation';
import useMediaQuery from '@/hooks/useMediaQuery';
import { desktop } from '@/constants/screensizes';
import { resolveReference } from '@/utils/lib/resolve-reference';
import useAccountRoles from '@/lib/hooks/useAccountRoles';
import { TasticProps } from '../types';
import { HeaderTasticProps } from './types';
import useHeaderData from './hooks/useHeaderData';

const HeaderTastic = ({ data }: TasticProps<HeaderTasticProps>) => {
  const { translate } = useTranslation();
  const [isDesktopSize] = useMediaQuery(desktop);

  const {
    businessUnits,
    selectedBusinessUnit,
    stores,
    selectedStore,
    quotes,
    totalCartItems,
    headerSearch,
    searchSuggestions,
    addToCart,
    onHeaderSearch,
    onBusinessUnitSelect,
  } = useHeaderData();

  const { isAdmin } = useAccountRoles(selectedBusinessUnit);

  const { permissions } = useAccountRoles(selectedBusinessUnit);

  return (
    <div className="h-[81px]">
      <div id="header-container" className="fixed top-0 z-50 w-full">
        <div className="relative">
          <Header
            isAdmin={isAdmin}
            csvDownloadLink="/template.csv"
            addToCartDisabled={!permissions.UpdateMyCarts}
            selectedBusinessUnit={selectedBusinessUnit}
            businessUnits={businessUnits}
            stores={stores}
            selectedStore={selectedStore}
            accountLink={resolveReference(data.accountLink)}
            accountLinkLabel={data.accountLinkLabel}
            cartItems={totalCartItems}
            cartLink={resolveReference(data.cartLink)}
            cartLinkLabel={data.cartLinkLabel}
            logo={data.logo}
            logoLink={resolveReference(data.logoLink)}
            ordersLink={resolveReference(data.ordersLink)}
            ordersLinkLabel={data.ordersLinkLabel}
            searchPlaceholder={
              isDesktopSize ? translate('common.search.placeholder') : translate('common.search.placeholder.mobile')
            }
            searchSuggestions={searchSuggestions}
            quotes={quotes?.length ?? 0}
            onBusinessUnitChange={onBusinessUnitSelect}
            headerSearch={headerSearch}
            onHeaderSearch={onHeaderSearch}
            addToCart={addToCart}
          />
        </div>
      </div>
    </div>
  );
};

export default HeaderTastic;
